import { render, staticRenderFns } from "./DeliveryNotificationDashboard.vue?vue&type=template&id=592d69ec"
import script from "./DeliveryNotificationDashboard.vue?vue&type=script&lang=js"
export * from "./DeliveryNotificationDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports